import React from 'react';
import { X, Trash2, Loader2 } from 'lucide-react';

const DeleteThreadModal = ({ isOpen, onClose, onConfirm, threadName = 'this thread', isLoading = false, isDeleteAll = false }) => {
  if (!isOpen) return null;

  const title = isDeleteAll ? 'Delete All Chats' : 'Delete Thread';
  const message = isDeleteAll 
    ? 'Are you sure you want to delete all chats? This will permanently remove all your chat history and cannot be undone.'
    : `Are you sure you want to delete "${threadName}"? This action cannot be undone.`;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-bg-60 rounded-xl p-6 w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-fg-40 hover:text-fg-50 transition-colors"
        >
          <X size={20} />
        </button>
        
        <div className="flex flex-col items-center mb-6">
          <div className="bg-red-500/20 p-3 rounded-full mb-3">
            <Trash2 size={24} className="text-red-500" />
          </div>
          <h2 className="text-xl font-semibold text-fg-50">{title}</h2>
          <p className="text-sm text-fg-60 mt-1 text-center">
            {message}
          </p>
        </div>
        
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-fg-60 hover:text-fg-50 hover:bg-bg-40 bg-bg-50 rounded-full transition-colors"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium bg-ac-02 text-white dark:text-black/70 hover:bg-ac-01 rounded-full transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                {isDeleteAll ? 'Deleting All...' : 'Deleting...'}
              </>
            ) : (
              <>
                {isDeleteAll ? 'Delete All' : 'Delete'}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteThreadModal;